import { render, staticRenderFns } from "./transfer-point.vue?vue&type=template&id=22e90953"
import script from "./transfer-point.vue?vue&type=script&lang=js"
export * from "./transfer-point.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports